<ngx-spinner bdColor = "rgba(238, 238, 238, .8)" size = "medium" color = "#FFB800" type = "ball-running-dots" [fullScreen] = "true"><p style="color: #1A1A1A" > Cargando... </p></ngx-spinner>

<div id="page-container">
	<app-view-header></app-view-header>
	<app-service-err-modal modalId="modal-service-error"></app-service-err-modal>
		<button id="modal-service-error-btn" type="button" class="btn btn-primary d-none" data-toggle="modal" data-target="#modal-service-error">
			.
		</button>
	<div class="container separacion_header_body content-wrap">
		<main>
			<router-outlet (activate)="onActivate($event)"></router-outlet>
		</main>
	</div>
	<app-view-footer id="footer"></app-view-footer>
</div>
